import { Accessibility, Accessible, Blind, EyeOff, TextFileds } from "../icons";
import {
	Accessibility as AccessibilityIcon,
	Circle,
	Eye,
	Settings,
	Volume2,
	User,
	Brain,
	Monitor,
} from "lucide-react";

export const tabs = [
	"general",
	"scans",
	"customization",
	"features",
	"statement",
	"license",
];
export const predefinedIcons = [
	{ name: "Accessibility", icon: Accessibility },
	{ name: "Accessible", icon: Accessible },
	{ name: "Blind", icon: Blind },
	{ name: "EyeOff", icon: EyeOff },
	{ name: "TextFileds", icon: TextFileds },
];

export const sizes = ["sm", "md", "lg"];
export const radius = ["sm", "md", "lg"];
export const sizeLabels = {
	sm: "Small",
	md: "Medium",
	lg: "Large",
};

export const radiusLabels = {
	sm: "Square",
	md: "Squircle Small",
	lg: "Rounded",
};
